import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import ReferralProgramFooter from 'modules/referral_program/components/ReferralProgramRevamp/ReferralProgramFooter'
import ReferralProgramHeader from 'modules/referral_program/components/ReferralProgramRevamp/ReferralProgramHeader'
import ReferralProgramSteps from 'modules/referral_program/components/ReferralProgramRevamp/ReferralProgramSteps'

const Content = () => {
  const { company, employee } = useCurrentSession()

  const mainLegalEntity = company.legalEntities.find((e) => e.main)
  const isoCountryCode = mainLegalEntity?.country || employee?.legalEntity?.country

  if (!isoCountryCode) {
    return null
  }

  return (
    <Box flexDirection="column" gap="s64">
      <ReferralProgramHeader isoCountryCode={isoCountryCode} />
      <Box
        justifyContent="center"
        flexDirection="row"
        style={{
          backgroundColor: '#05386B05',
          marginLeft: '-24px',
          marginRight: '-24px',
        }}
      >
        <ReferralProgramSteps />
      </Box>
      <Box justifyContent="center" flexDirection="row">
        <ReferralProgramFooter isoCountryCode={isoCountryCode} />
      </Box>
    </Box>
  )
}

export default Content
